export const version = '5.0.0'
export const supportLink = 'https://www.cellcrypt.com/about'
export const companyName = 'CSG Inc'
export const platformName = 'Cellcrypt Federal'
export const mode: 'public' | 'private' = 'public'
export const storeURL = 'https://www.cellcrypt.com/federal-store'
export const flavor = 'ccfed'
export const CAPTCHA_KEY = '6LdfK90qAAAAAAtUf3g3CQC4L7iOqb0Rk7VtbhYv'
